<template>
  <reg-card :show-back="true" @back="$emit('back')">
    <p class="eyebrow">ESTÁ QUASE LÁ</p>
    <h2 class="title">Confirmar o email</h2>
    <p class="sub">
      Enviamos um email com um código para
      <span class="orange">{{ email }}</span
      >, por favor insira o código que recebeu no seu email para avançar.
    </p>

    <div class="otp-wrap">
      <input
        v-for="i in 5"
        :key="i"
        :ref="`o${i}`"
        v-model="otp[i - 1]"
        class="otp"
        :class="{ err: !!erroOtp, filled: otp[i - 1] }"
        maxlength="1"
        inputmode="numeric"
        @input="onInput(i, $event)"
        @keydown="onKeydown(i, $event)"
        @paste.prevent="onPaste($event)"
      />
    </div>
    <p v-if="erroOtp" class="err-msg text-center">{{ erroOtp }}</p>

    <button
      class="btn-dark"
      :disabled="loading || otp.join('').length < 5"
      @click="submit"
    >
      <span v-if="loading" class="spinner"></span>
      <span v-else>CONTINUAR</span>
    </button>

    <div class="links">
      <button class="link" :disabled="timer > 0" @click="reenviar">
        {{ timer > 0 ? `Reenviar código (${timer}s)` : "Reenviar código" }}
      </button>
      <button class="link" @click="$emit('back')">Alterar o email</button>
    </div>
  </reg-card>
</template>

<script>
  import RegCard from "../components/RegCard.vue";
  import { registerService } from "../../../../services/register.service";

  export default {
    name: "RegStep2",
    components: { RegCard },
    props: {
      email: { type: String, required: true },
    },
    data() {
      return {
        otp: ["", "", "", "", ""],
        erroOtp: "",
        loading: false,
        timer: 60,
        interval: null,
      };
    },
    mounted() {
      this.iniciarTimer();
      this.$nextTick(() => this.$refs["o1"]?.[0]?.focus());
    },
    beforeDestroy() {
      clearInterval(this.interval);
    },
    methods: {
      iniciarTimer() {
        this.timer = 60;
        clearInterval(this.interval);
        this.interval = setInterval(() => {
          if (--this.timer <= 0) clearInterval(this.interval);
        }, 1000);
      },
      onInput(i, e) {
        const v = e.target.value.replace(/\D/g, "").slice(-1);
        this.$set(this.otp, i - 1, v);
        this.erroOtp = "";
        if (v && i < 5)
          this.$nextTick(() => this.$refs[`o${i + 1}`]?.[0]?.focus());
      },
      onKeydown(i, e) {
        if (e.key === "Backspace" && !this.otp[i - 1] && i > 1)
          this.$nextTick(() => this.$refs[`o${i - 1}`]?.[0]?.focus());
      },
      onPaste(e) {
        const text = e.clipboardData
          .getData("text")
          .replace(/\D/g, "")
          .slice(0, 5);
        if (!text) return;
        text.split("").forEach((c, idx) => {
          if (idx < 5) this.$set(this.otp, idx, c);
        });
        this.$nextTick(() => this.$refs["o5"]?.[0]?.focus());
      },
      async submit() {
        this.erroOtp = "";
        this.loading = true;
        try {
          await registerService.verificarEmail(this.email, this.otp.join(""));
          this.$emit("done");
        } catch (err) {
          this.erroOtp =
            err.response?.data?.error || "Código inválido ou expirado.";
          this.otp = ["", "", "", "", ""];
          this.$nextTick(() => this.$refs["o1"]?.[0]?.focus());
        } finally {
          this.loading = false;
        }
      },
      async reenviar() {
        if (this.timer > 0) return;
        try {
          await registerService.reenviarCodigo(this.email);
          this.otp = ["", "", "", "", ""];
          this.erroOtp = "";
          this.iniciarTimer();
          this.$notify({
            type: "success",
            title: "Código reenviado",
            message: "Verifica o teu email.",
          });
        } catch (err) {
          this.$notify({
            type: "danger",
            title: "Erro",
            message: err.response?.data?.error || "Erro ao reenviar.",
          });
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .eyebrow {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.12em;
    color: #b0a8a0;
    text-transform: uppercase;
    margin-bottom: 6px;
  }
  .title {
    font-size: 22px;
    font-weight: 800;
    color: #1a1210;
    margin-bottom: 12px;
  }
  .sub {
    font-size: 13.5px;
    color: #7a736e;
    margin-bottom: 20px;
    line-height: 1.5;
  }
  .orange {
    color: #ff825d;
    font-weight: 600;
  }
  .otp-wrap {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin: 8px 0 4px;
  }
  .otp {
    width: 52px;
    height: 60px;
    border: 2px solid #e8e4e0;
    border-radius: 12px;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    color: #1a1210;
    outline: none;
    font-family: inherit;
    transition: border-color 0.15s;
    &:focus,
    &.filled {
      border-color: #ff825d;
    }
    &.err {
      border-color: #e53e3e;
    }
  }
  .err-msg {
    font-size: 12px;
    color: #e53e3e;
    margin-top: 4px;
    text-align: center;
  }
  .btn-dark {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 50px;
    border: none;
    border-radius: 10px;
    background: #1a1210;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.05em;
    cursor: pointer;
    font-family: inherit;
    margin-top: 16px;
    &:hover:not(:disabled) {
      background: #2d2420;
    }
    &:disabled {
      opacity: 0.55;
      cursor: default;
    }
  }
  .spinner {
    width: 18px;
    height: 18px;
    border: 2px solid rgba(255, 255, 255, 0.4);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
  }
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  .links {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
  }
  .link {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 13px;
    color: #b0a8a0;
    font-family: inherit;
    transition: color 0.15s;
    &:hover:not(:disabled) {
      color: #ff825d;
    }
    &:disabled {
      opacity: 0.5;
      cursor: default;
    }
  }
</style>
